import React from 'react'
import { Feed } from 'semantic-ui-react';
import momentDateAndTime from '../../../../../helpers/momentDateAndTime'
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import { toastr } from 'react-redux-toastr';
import ImageAvater from '../../../../drive/Components/ImageAvater';
let moment = require('moment');

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Notes Card')
    }
})
class Comment extends React.Component {

    async setCurrntNotes(data, clickStatus) {
        await dispatch.initiatives.setCurrntNotesAsync(data);
        this.props.notesClick(true, clickStatus);
    }

    DeleteNotes(note) {
        let message = <div className="confirmMessage">
            <h3>Delete Comment</h3>
            <p>Are you sure that you wish to delete this note?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                let index = this.props.notes.indexOf(note);
                if (index > -1) {
                    (this.props.notes).splice(index, 1)
                    if (this.props.string === 'intiativeOverview') {
                        let initiativeLog = {
                            "accountUserId" : this.props.user._id,
                            "commentDate" : moment()
                        }
                        let name = this.props.user.firstName +' '+ this.props.user.lastName;
                        initiativeLog.comment = `${name} has deleted comment.\nComment: ${note.content}`;
                        this.props.selectedData.initativeLogs.unshift(initiativeLog);
                        let notificationText = `${name} has deleted comment in an initiative ${this.props.selectedData.name}.`;
                        dispatch.initiatives.updateInitiativeBySpecificFields({ _id: this.props.selectedData._id, notes: this.props.selectedData.notes, initativeLogs: this.props.selectedData.initativeLogs, notificationText:notificationText })
                    }
                    else if (this.props.string === 'intiativeActivityProgressView') {
                        let eventData = {
                            "userId" : this.props.user._id,
                            "initiativeId" : this.props.selectedData.initiativeId._id,
                            "activityId" : this.props.selectedData._id,
                            "event" : "customEvent"
                        }
                        eventData.type = 'commentDeleted';
                        let name = this.props.user.firstName +' '+ this.props.user.lastName;
                        eventData.notificationText = `${name} has deleted comment under ${this.props.selectedData.name} in an initiative ${this.props.selectedData.initiativeId.name}`;
                        this.props.selectedData.eventData = eventData;
                        this.props.selectedData.string = 'commentDeleted';
                        this.props.selectedData.text = note.content;
                        dispatch.initiatives.updateInitiativeActivities(this.props.selectedData);
                    }
                }
            }
        });
    }

    render() {
        let notes;
        if (this.props.notes && this.props.notes.length > 0) {

            notes = this.props.notes.map((item, i) => {
                let accountUserId = item.accountUserId._id ? item.accountUserId._id : item.accountUserId;
                return <Feed key={i} className={`issueMessage bg-white pad_5`} style={{ padding: 0, margin: "10px 0 0 0", background: "none" }} >
                    <Feed.Event>
                        <ImageAvater user={item.accountUserId} className="clr-white w_24 h_24" imageStyle="clr-white w_24 h_24" />
                        <Feed.Content>
                            <Feed.Summary>
                                {item.accountUserId.firstName} {item.accountUserId.lastName}
                                <span className="pull-right">
                                    {momentDateAndTime(item.notedate)}
                                    <br />
                                    {(accountUserId.toString() === this.props.user._id.toString() || (this.props.role == "workspaceOwner")) && (this.props.status === 1 || this.props.status === 2) ?
                                        <span className="clr-blue text-underline pull-right cursor-pointer" style={{ "marginLeft": "10px" }} onClick={() => this.DeleteNotes(item)}>Delete</span>
                                        : ''}

                                    {(accountUserId.toString() === this.props.user._id.toString() || (this.props.role == "workspaceOwner")) && (this.props.status === 1 || this.props.status === 2) ?
                                        <span className="clr-blue text-underline pull-right cursor-pointer" onClick={() => this.setCurrntNotes(item, "editNote")}>Edit</span>
                                        : ''}
                                </span>
                            </Feed.Summary>
                        </Feed.Content>
                    </Feed.Event>
                    <Feed.Event>
                        <Feed.Content>
                            <div dangerouslySetInnerHTML={{
                                __html:
                                    item.content.includes('Note:') ?
                                        item.content.substring(
                                            item.content.indexOf("Note:") + 5
                                        ) :
                                        item.content
                            }} />
                        </Feed.Content>
                    </Feed.Event>

                </Feed>
            })
        } else {
            notes = "No Comment Added"
        }

        return (
            <div>
                {notes}

            </div>
        )
    }
}

export default Comment